// ZIP archives with fflate (in place of SuiteCompile/Zip.swift): files in the order added, `mimetype` stored
// uncompressed as EPUB requires, every entry dated 1980-01-01 as the Swift's writer dates them, and a reader.
import { strFromU8, strToU8, unzipSync, zipSync, type Zippable } from 'fflate';

export class ZipWriter {
  private files: [string, Uint8Array, boolean][] = [];

  /** Adds a file. `store` writes it uncompressed. */
  add(name: string, contents: string | Uint8Array, store = false): void {
    this.files.push([name, typeof contents === 'string' ? strToU8(contents) : contents, store]);
  }

  finish(): Uint8Array {
    const zippable: Zippable = {};
    for (const [name, data, store] of this.files) zippable[name] = [data, { level: store ? 0 : 6, mtime: new Date(1980, 0, 1) }];
    return zipSync(zippable);
  }
}

/** Reads an archive's entries; throws on anything that isn't a readable ZIP. */
export class ZipReader {
  readonly entries: Map<string, Uint8Array>;

  constructor(data: Uint8Array) {
    const files = unzipSync(data);
    this.entries = new Map(Object.entries(files).filter(([name]) => !name.endsWith('/')));
  }

  data(name: string): Uint8Array | null { return this.entries.get(name) ?? null; }

  text(name: string): string | null {
    const d = this.entries.get(name);
    return d ? strFromU8(d) : null;
  }
}

export const utf8 = (s: string) => strToU8(s);
export const fromUTF8 = (d: Uint8Array) => strFromU8(d);
